import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class CustomerVerificationConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	isNoWelcomePageAfterLoginEnabled(): boolean {
		return this.service.get((x) => x.common.registration.isNoWelcomePageAfterLoginEnabled, false);
	}
}
